<section fxLayoutAlign="end center">
  <sbnb-close [border]="true" (click)="dialogRef.close()"></sbnb-close>
</section>

<section fxFlexFill fxLayout fxLayoutAlign="center center">
  <div fxLayout="column" fxLayoutAlign="space-between" class="fs-dialog-contents">
    <div fxFlex fxLayoutGap="12px">
      <h2>Match locks to the properties where they are installed</h2>
    </div>

    <div fxFlex fxLayoutAlign="start center" fxLayoutGap="12px" class="smartlock-edit-header">
      <img
        fxHide.lt-md
        fxFlex="0 0 36px"
        height="36px"
        src="/assets/images/apps/integrations/schlage.svg"
        *ngIf="integration === 'Schlage'" />
      <img
        fxHide.lt-md
        fxFlex="0 0 36px"
        height="36px"
        src="/assets/images/apps/integrations/remote-lock.svg"
        *ngIf="integration === 'RemoteLock'" />
      <img
        fxHide.lt-md
        fxFlex="0 0 36px"
        height="36px"
        src="/assets/images/apps/integrations/august-lock.svg"
        *ngIf="integration === 'August'" />
      <img
        fxHide.lt-md
        fxFlex="0 0 36px"
        height="36px"
        src="/assets/images/apps/integrations/yale.svg"
        *ngIf="integration === 'Yale'" />
      <img
        fxHide.lt-md
        fxFlex="0 0 36px"
        height="36px"
        src="/assets/images/apps/integrations/smartthings.svg"
        *ngIf="integration === 'SmartThings'" />
      <img
        fxHide.lt-md
        fxFlex="0 0 36px"
        height="36px"
        src="/assets/images/apps/integrations/nuki.svg"
        *ngIf="integration === 'Nuki'" />
      <img
        fxHide.lt-md
        fxFlex="0 0 36px"
        height="36px"
        src="/assets/images/apps/integrations/igloo.svg"
        *ngIf="integration === 'IglooHome'" />
      <img
        fxHide.lt-md
        fxFlex="0 0 36px"
        height="36px"
        src="/assets/images/apps/integrations/ttlock-circle.svg"
        *ngIf="integration === 'TTLock'" />

      <div fxFlex fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="12px" *ngIf="lock.additional_info">
        <h3 fxLayoutAlign="space-between center">
          <span>{{ lock.additional_info.display_name }}</span>
          <span class="smartlock-serial" *ngIf="integration == 'RemoteLock'">
            Serial: {{ lock.additional_info.serial_number }}
          </span>
        </h3>

        <span>{{ lock.additional_info.manufacturer }}</span>
      </div>

      <div fxFlex fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="12px" *ngIf="!lock.additional_info">
        <h3 fxLayoutAlign="space-between center">
          <span>Matched Schlage lock</span>
        </h3>
      </div>
    </div>

    <div class="relative">
      <sbnb-property-selection
        [selectedProperties]="lock.properties"
        [allPropertiesEnabled]="false"
        [border]="true"
        [listHeight]="280"
        (propertiesChange)="setLockProperties($event)"
        (newPropertyChecked)="newPropertyChecked($event)"
        [disabled]="!lock.is_supported"></sbnb-property-selection>
      <div class="unsupported" *ngIf="!lock.is_supported">
        <div class="mat-tooltip">
          {{ lock.unsupported_message }}
        </div>
      </div>
    </div>

    <div
      fxLayout
      fxLayoutAlign="end start"
      fxLayout.lt-md="column"
      fxLayoutGap="12px"
      fxLayoutGap.lt-md="8px"
      class="smartlock-digits-container">
      <strong class="profile__label text__small">PIN code length:</strong>

      <div fxFlex="60px" fxFlex.lt-md="none">
        <mat-form-field class="fw nopadding input__mini">
          <input
            name="number"
            [(ngModel)]="lock.code_length"
            (change)="validateCodeLengthInput()"
            type="number"
            matInput
            [min]="lock.additional_info ? lock.additional_info.min_length_pincode : lock.code_length"
            [max]="lock.additional_info ? lock.additional_info.max_length_pincode : lock.code_length"
            [disabled]="!lock.additional_info"
            [placeholder]="4" />
        </mat-form-field>
      </div>
    </div>

    <div fxLayoutAlign="end left" fxLayoutGap="8px" style="margin-top: 32px">
      <sbnb-button
        *ngIf="this.locks.length < 1 && !this.lock.serial_number && lock.is_supported"
        label="Save"
        [loading]="saving"
        (clicked)="editSmartlock()"></sbnb-button>

      <sbnb-button
        *ngIf="this.locks.length < 1 && this.lock.serial_number && lock.is_supported"
        label="Save"
        [loading]="saving"
        (clicked)="storeUnlinkedSmartlock()"></sbnb-button>

      <sbnb-button
        *ngIf="this.locks.length > 0"
        label="Don't match this lock"
        type="secondary"
        [loading]="saving"
        (clicked)="avoidMatch()"></sbnb-button>

      <sbnb-button
        *ngIf="this.locks.length > 1 && this.locks.length > this.lockIndex + 1 && lock.is_supported"
        label="Continue to the next lock"
        [loading]="saving"
        (clicked)="storeSmartlock()"></sbnb-button>

      <sbnb-button
        *ngIf="this.locks.length > 0 && this.locks.length == this.lockIndex + 1 && lock.is_supported"
        label="Continue"
        [loading]="saving"
        (clicked)="storeSmartlock()"></sbnb-button>
    </div>
  </div>
</section>
